<template>
<div class="animated fadeIn">

    <CCard>
      <CCardHeader>
        <slot name="header">
          <!-- <span class="title-card-list"><i class="fa fa-align-justify mr-1"></i> Listado de {{ elemento }}</span> -->
          <span class="card-detail-header-title"> <i class="fa fa-align-justify mr-1"></i> Listado de {{ elemento }} </span>
        </slot>

        <div class="card-header-actions">
          <CBadge class="pull-right" style="padding: 0.3rem 0.5rem;" pill color="dark">Total: {{ itemsList.length }}</CBadge>
        </div>
      </CCardHeader>

      <div v-if="loading" class="text-center m-5">
        <div class="spinner-grow text-primary m-auto" style="width: 3rem; height: 3rem;" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div v-else>

        <CCardBody>

          <CDataTable
            :items="itemsList"
            :fields="campos"
            column-filter
            sorter
            hover
            :noItemsView="{ noResults: ' sin resultados disponibles ' , noItems: ' sin resultados' }"
          >

          <!-- clickable-rows -->
          <!--  @row-clicked="goToDetail" -->


            <template #over-table v-if="excel">
              <div d-flex flex-row class="acciones-disponibles mb-3 row-over-table">
                <CButton :disabled="loading"  @click="generateExcel"
                  v-c-tooltip.hover.click="'Ajusta el listado con el Filtro'"
                  class="mr-2" type="submit" size="sm" variant="outline" color="success">
                  <i class="fa fa-file-excel-o mr-1"></i> Descargar Excel
                </CButton>
              </div>
            </template>

            <template #seleccionar="{item}">
              <td>
                <CInputCheckbox
                  :checked="item._selected"
                  @update:checked="() => check(item)"
                  custom
                />
              </td>
            </template>

            <template #datetime="{item}">
              <td>
                {{formatDateTimeCustom(item.datetime)}}
              </td>
            </template>

            <template #pin="{item}">
              <td>
                <span v-if="item.pin">{{item.pin}}</span>
              </td>
            </template>


            <template #card_reader_id="{item}">
              <td>
                <span v-if="item.card_reader_id"> {{ stringUtils.getReaderLabel(item.card_reader_id)}} </span>
              </td>
            </template>


            <template #client="{item}">
              <td>
                  <span>{{ item.client.name }}  {{ item.client.surnames }}</span>
              </td>
            </template>

            <template #parking="{item}">
              <td >
                <template v-if="!item.parking.deleted_at">
                  <router-link target="_blank" class="text-link-list" :to="'/parkings/' + item.parking.id">
                    <span>{{ stringUtils.getParkingName(item.parking) }}</span>
                  </router-link>
                </template>
                <template v-else>
                  <span>{{ stringUtils.getParkingName(item.parking) }}</span>
                </template>
              </td>
            </template>

          </CDataTable>

          <nav>
            <div class="overflow-auto">
              <CPagination
                align="center"
                class="md-12"
                v-show="total_paginas > 1"
                :pages="total_paginas"
                :active-page.sync="currentPageSon"
                :per-page="perPage"
                @update:activePage="cambiarPagina"
              />
            <p class="text-muted text-center">Se han encontrado {{getRowCount()}} resultados</p>
            </div>
          </nav>


        </CCardBody>


      </div>

    </CCard>


  <!-- <toast ref="toast"></toast> -->
  </div>
</template>

<script>

// import Toast from "@/app/shared/components/Toast";
// import BadgeStatus from '@/components/badges/BadgeStatus';
// import BadgePaymentStatus from '@/components/badges/BadgePaymentStatus';

import stringUtils from "@/app/shared/utils/stringUtils";
import {formatDateTimeCustom} from '@/app/shared/utils/utils';
export default {
  name: 'EventsList',
  components: {
    // Toast,
    // BadgeStatus,
    // BadgePaymentStatus
  },
  props: {
    elemento: { type: String, default: 'Listado de Eventos'},
    title: String,
    loading: Boolean,
    events: { type: Array, default: [], required: true },
    excel: { type: Boolean, default: false},
    rows: { type: Number, default: 0 },
    pagina_actual:  { type: Number, default: 1 },
    currentPage:  { type: Number, default: 1 },
    perPage:  { type: Number, default: 25 },
    total_paginas:  { type: Number, default: 1 },
  },
  data() {
    return {
      formatDateTimeCustom: formatDateTimeCustom,
      campos: [
        // { key: "seleccionar", label: "", thStyle: { width: "50px" }  ,  _style: 'width:1%', sorter: false, filter: false},
        // { key: "id", label: "Id", thStyle: { width: "50px" }  ,  _style: 'width:1%', sorter: true, filter: false},
        { key: "datetime", label: "Fecha evento", sorter: true, filter: false},
        { key: "type", label: "Evento", sorter: true , filter: false},
        { key: "card_reader_id", label: "Lector", sorter: true , filter: false},
        { key: "client", label: "Cliente", sorter: true, filter: false },
        { key: "pin", label: "Pin acceso", sorter: true, filter: false },
        { key: "parking", label: "Parking", sorter: true, filter: false },
        // { key: "acciones", label: "Acciones", _style: 'width:15%', sorter: false, filter: false, _classes: 'text-center'},
      ],
      modelDelete: false,
      allChecked:false,
      stringUtils: stringUtils,
    }
  },
  mounted(){
  },
  created(){
  },
  computed: {
    items:{
      get: function () {
        return this.events;
      },
      set: function (newValue) {
        this.$emit("update:events", newValue);
      },
    },
    itemsList () {
      if (this.items) {
        return this.items.map(user => {
          return {
            ...user,
            _classes: [
              user._classes,
              user._selected ? 'table-selected' : 'table-unselected'
            ]
          }
        })
      }
    },
    currentPageSon: {
      get: function () {
        return this.currentPage;
      },
      set: function (newValue) {
        this.$emit("update:currentPage", newValue);
      },
    }
  },
  methods: {
    selectToEdit(item){
      this.$emit('select', item)
    },
    selectToDelete(item){
      this.$emit('delete', item)
    },
    getRowCount: function() {
      return this.rows;
    },
    cambiarPagina(e) {
      this.$emit('cambiarPagina', e)
    },
    selectAllItems(){
      if (this.items.every( item => item._selected === true)){
        this.$emit('updateChecked', false);
        this.allChecked = false;

      } else {
        this.$emit('updateChecked', true);
        this.allChecked = true;
      }
    },
    rowClicked (item, index, column, e) {
      if (!['INPUT', 'LABEL'].includes(e.target.tagName)) {
        this.check(item)
      }
    },
    check (item) {
      const data = this.items.filter( user => user.id == item.id)[0];
      const val = Boolean(this.items[this.items.indexOf(data)]._selected);

      this.items[this.items.indexOf(data)]._selected = !val;
      this.items[this.items.indexOf(data)].checked = !val;

      this.items = [...this.items];
    },
    goToDetail(item, index, column, e){
      if (!['INPUT', 'LABEL'].includes(e.target.tagName)
      && !['client', 'parking', 'acciones'].includes(column)) {
        this.$router.push({ path: `/gestion/eventos/${item.id}`});
        // let routeData = this.$router.resolve({path: `/gestion/eventos/${item.id}`});
        // window.open(routeData.href, '_blank');
      }
    },
    generateExcel(){
      this.$emit('excel', true)
    }


  }


}
</script>

<style lang="scss">

</style>

